import api from "../../../api";

const LOCATION_CACHE_TTL_MS = 10 * 60 * 1000;
let locationRequest = null;

export default {
  async getLocation({ commit, state }, options = {}) {
    const cacheIsFresh = state.status === "success" &&
      Date.now() - state.loadedAt < LOCATION_CACHE_TTL_MS;
    if (!options.force && cacheIsFresh) return state.Locations;
    if (locationRequest) return locationRequest;

    locationRequest = (async () => {
      commit("REQUEST_LOCATIONS");
      if (!options.silent) commit("SET_LOADING", true, { root: true });
      try {
        const result = await api.getLocation();
        commit("SUCCESS_REQUEST_LOCATIONS", result);
        commit("SET_LOCATIONS_LOADED_AT", Date.now());
        return result.body;
      } catch (err) {
        if (!err.ok && err.status === 401) {
          commit("TO_LOGIN", true, { root: true });
        }
        commit("FAILURE_REQUEST_LOCATIONS");
        return null;
      } finally {
        if (!options.silent) commit("SET_LOADING", false, { root: true });
      }
    })();

    try {
      return await locationRequest;
    } finally {
      locationRequest = null;
    }
  },
  async deleteLocation({ commit }, id) {
    commit("REQUEST_DELETE_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.deleteLocation(id);
      commit("SUCCESS_REQUEST_DELETE_LOCATION", result);
      commit("DEACTIVATE_CACHED_LOCATION", id);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_DELETE_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateLocation({ commit }, item) {
    commit("REQUEST_UPDATE_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.updateLocation(item);
      commit("SUCCESS_REQUEST_UPDATE_LOCATION", result);
      commit("UPSERT_LOCATION", result.body);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createLocation({ commit }, item) {
    commit("REQUEST_CREATE_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.createLocation(item);
      commit("SUCCESS_REQUEST_CREATE_LOCATION", result);
      commit("UPSERT_LOCATION", result.body);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_CREATE_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async moveLocation({ commit }, item) {
    commit("REQUEST_MOVE_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit("SUCCESS_REQUEST_MOVE_LOCATION", item);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_MOVE_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deactivateLocation({ commit }, id) {
    commit("REQUEST_DEACTIVATE_LOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DEACTIVATE_LOCATION", 
        await api.deactivateLocation(id)
        );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_DEACTIVATE_LOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
